module.exports = __webpack_public_path__ + "static/media/photography.8a25ac2a.png";